﻿export interface IXmTracking {
    id: number,
    swapNumber: string,
    recipientCenterId: number,
    recipientCenterAlias: string,
    recipientId: number,
    recipientAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    rdnCenterId: number,
    rdnCenterAlias: string,
    donorId: number
    donorAlias: string,
    chainNumber: number,
    clusterNumber: number,
    positionNumber: number,
    isCryoXm: boolean,
    isViracorCryo: boolean,
    isDcComplete: boolean,
    xmTypeId: number,
    xmTypeDescription: string,
    xmStatusId: number,
    xmStatusDescription: string,
    xmShipMethodId: number,
    xmShipMethodDescription: string,
    shipOutDate: string,
    shipOutTrackingNumber: string,
    shipBackTrackingNumber: string,
    remoteSendTrackingNumber: string,
    xmResultId: number,
    xmResultDescription: string,
    receivedDate: string,
    receivedOnTime: boolean,
    requestedDate: string,
    resultsRecordedDate: string,
    xmStatusDeadline: string,
    dateResultsDue: string,
    receivedBackDate: string,
    remoteSendDate: string,
    shipBackDate: string,
    channelShiftT: string,
    channelShiftB: string,
    comments: string,
    correctiveAction: string,
    donorRawTypingUploadPath: string,
    donorCtReportUploadPath: string,
    donorMedChartUploadPath: string,
    isRequestingCenter: boolean,
    uploadFinalXmResults: boolean,
    daysBeforeSurgery: number,
}

export interface ILateFinalXm  {
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenter: string,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenter: string,
    rdnCenterId: number,
    rdnCenter: string,
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    uploadDateTime: string,
    deadlineDate: string,
    transplantDate: string,
    uploadDiffDays: number
    daysLate: number,
    xmTrackingId: number,
    requestedDate: string,
    statusId: number,
    status: string
}